import { render } from "./MyResults.vue?vue&type=template&id=6aa04534&scoped=true"
import script from "./MyResults.vue?vue&type=script&lang=js"
export * from "./MyResults.vue?vue&type=script&lang=js"

import "./MyResults.vue?vue&type=style&index=0&id=6aa04534&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa04534"]])

export default __exports__